"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FullScreenV2 = exports.FullScreen = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Loader = _interopRequireWildcard(require("./Loader.style"));

var _FullscreenPortalLoader = _interopRequireDefault(require("./FullscreenPortalLoader"));

var Loader = function Loader(_ref) {
  var width = _ref.width,
      height = _ref.height,
      style = _ref.style,
      svgColor = _ref.svgColor,
      className = _ref.className;
  return _react.default.createElement(_Loader.default, {
    style: style,
    width: width,
    height: height,
    viewBox: "0 0 66 66",
    className: (0, _classnames.default)('Loader', className)
  }, _react.default.createElement("circle", {
    className: "path",
    fill: "none",
    strokeWidth: "6",
    strokeLinecap: "round",
    cx: "33",
    cy: "33",
    r: "30",
    style: {
      stroke: svgColor
    }
  }));
};

var FullScreen = function FullScreen(props) {
  return _react.default.createElement(_Loader.FullScreenWrapper, null, _react.default.createElement(Loader, props));
};

exports.FullScreen = FullScreen;

var FullScreenV2 =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(FullScreenV2, _React$Component);

  function FullScreenV2() {
    (0, _classCallCheck2.default)(this, FullScreenV2);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FullScreenV2).apply(this, arguments));
  }

  (0, _createClass2.default)(FullScreenV2, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      (0, _FullscreenPortalLoader.default)(true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _FullscreenPortalLoader.default)(false);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return FullScreenV2;
}(_react.default.Component);

exports.FullScreenV2 = FullScreenV2;
Loader.propTypes = {
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  style: _propTypes.default.object,
  svgColor: _propTypes.default.string
};
Loader.defaultProps = {
  width: 40,
  height: 40,
  style: {},
  svgColor: ''
};
var _default = Loader;
exports.default = _default;